import React from "react";
import "../styles/apv.css";

const Apv = () => {
  return (
    <>
      <h1 className="apvh1">ஆசிரியர் பாராட்டு விழா</h1>
      <div className="apvmain">
        <img src="/images/apv.jpg" alt="" className="apvimg" />
      </div>
    </>
  );
};

export default Apv;
